import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

// Helper plans (fallback if API offline) — v1.11 XOF catalogue
// accounts: 0 means unlimited ; max number of MT5 accounts otherwise
export const PLAN_META = {
  "single-1m":     { tier: "single",    duration: "1m",  xof: 100000,   usd: 160,   accounts: 2, days: 30,   popular: false },
  "single-3m":     { tier: "single",    duration: "3m",  xof: 270000,   usd: 432,   accounts: 2, days: 90,   popular: false, saveLabel: "−10%" },
  "single-6m":     { tier: "single",    duration: "6m",  xof: 500000,   usd: 800,   accounts: 2, days: 180,  popular: false, saveLabel: "−17%" },
  "single-12m":    { tier: "single",    duration: "12m", xof: 900000,   usd: 1440,  accounts: 2, days: 365,  popular: false, saveLabel: "−25%" },

  "multi-1m":      { tier: "multi",     duration: "1m",  xof: 300000,   usd: 480,   accounts: 6, days: 30,   popular: false },
  "multi-3m":      { tier: "multi",     duration: "3m",  xof: 800000,   usd: 1280,  accounts: 6, days: 90,   popular: true,  saveLabel: "−11%" },
  "multi-6m":      { tier: "multi",     duration: "6m",  xof: 1500000,  usd: 2400,  accounts: 6, days: 180,  popular: true,  saveLabel: "−17%" },
  "multi-12m":     { tier: "multi",     duration: "12m", xof: 2700000,  usd: 4320,  accounts: 6, days: 365,  popular: true,  saveLabel: "−25%" },

  "unlimited-1m":  { tier: "unlimited", duration: "1m",  xof: 900000,   usd: 1440,  accounts: 0, days: 30,   popular: false },
  "unlimited-3m":  { tier: "unlimited", duration: "3m",  xof: 2400000,  usd: 3840,  accounts: 0, days: 90,   popular: false, saveLabel: "−11%" },
  "unlimited-6m":  { tier: "unlimited", duration: "6m",  xof: 4500000,  usd: 7200,  accounts: 0, days: 180,  popular: false, saveLabel: "−17%" },
  "unlimited-12m": { tier: "unlimited", duration: "12m", xof: 8100000,  usd: 12960, accounts: 0, days: 365,  popular: false, saveLabel: "−25%" },
};

export const formatXof = (n) => `${n.toLocaleString("fr-FR").replaceAll(",", " ")}`;
